import Layout from "../../components/Layout"
import { Grid, Stack } from "@mui/material"
import { UPMain, MPWrapper } from "./Atom"
import { UserProfileHeader } from "../../components/Headers"
import { UserDetails, UserInfo } from "../../components/Cards"
import MyInfo from "../../components/Cards/MyInfoCard"
import { useSelector } from "react-redux"
import {
  clearLocalstorage,
  deleteTokenLocal,
  getTokenLocal,
} from "../../../helper/utils"
import { setUserLogIn } from "../../redux/slices/appSlice"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import UserAPI from "../../../api/user"
import { useResponseHandle } from "../../hooks"
import { setCurrentUser } from "../../redux/slices/adminSlice"
import MyDetails from "../../components/Cards/MyDetailsCard"

const userAPI = new UserAPI()

const MyProfile = () => {
  const currentUser = useSelector((state: any) => {
    return state.admin.currentUser
  })

  const token: any = getTokenLocal()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const updateUserContactNumber = async (contactNumber: any) => {
    const response = await userAPI.updateUserContactNumber(
      token,
      currentUser?.uid,
      contactNumber,
    )
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(
          setCurrentUser({ ...currentUser, contact_number: contactNumber }),
        )
      }
    } else {
      navigate("/auth")
    }

    return result
  }

  const handleLogout = () => {
    clearLocalstorage()
    dispatch(setUserLogIn(false))
    toast.success("Logged out successfully")
    navigate("/auth")
  }

  return (
    <MPWrapper>
      {/* <UserProfileHeader name="My Profile" /> */}
      <UPMain>
        <Stack
          display={"flex"}
          direction={"row"}
          spacing={2}
          // paddingX={"25px"}
          // paddingY={"35px"}
          padding={"25px"}
          height={"100%"}
        >
          <Grid sx={{ flex: 1 }}>
            <MyInfo
              handleLogout={handleLogout}
              currentUser={currentUser}
              updateUserContactNumber={updateUserContactNumber}
            />
          </Grid>
          <Grid sx={{ flex: 3.5 }}>
            {/* <UserDetails /> */}
            <MyDetails />
          </Grid>
        </Stack>
      </UPMain>
    </MPWrapper>
  )
}

export default MyProfile
